export default "__VITE_ASSET__C$V6qKVa__"